import { StationStatus } from "../types"

export const approvedStatuses = [
    StationStatus.Open,
    StationStatus.Close,
    StationStatus.Inactive
]

export const approvedAndLastYearStation = [
    ...approvedStatuses,
    StationStatus.LastYear
]

export const editingStatuses = [
    StationStatus.Editing,
    StationStatus.ApprovalPending
]